import CrudRepository from './CrudRepository'

export default class LoginRepository extends CrudRepository {
  constructor () {
    super('api/users/login')
  }
}
